import React from "react";
import { CornerRibbon, CornerRibbonContent, CornerRibbonInner } from "./styles";
import { NodeEnvironment, environmentConfig } from "@src/appV2/environment";

// FIXME: Automatically disabled during ESLint config update
// eslint-disable-next-line react/function-component-definition
export const EnvironmentRibbon: React.FC = () => {
  const envName = environmentConfig.REACT_APP_ENVIRONMENT_NAME ?? import.meta.env.MODE;

  if (envName === NodeEnvironment.PRODUCTION) {
    return null;
  }

  return (
    <CornerRibbon>
      <CornerRibbonInner>
        <CornerRibbonContent>{envName.substring(0, 3).toUpperCase()}</CornerRibbonContent>
      </CornerRibbonInner>
    </CornerRibbon>
  );
};
